<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><em class="fas fa-truck-moving"></em></span
    >{{ "IntransitUpdate.Header" | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="grid">
            <!---- 查詢表單輸入欄位 --------------------------------------------------------------------------------------------------------->
            <div class="p-fluid col-12 grid">
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "IntransitUpdate.Search.hawb" | translate }}
                </div>
                <div class="block">
                  <p-chips
                    [(ngModel)]="searchParams.hawbs"
                    separator=","
                    formControlName="hawbs"
                  ></p-chips>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "IntransitUpdate.Search.forwarderName" | translate }}
                </div>
                <div class="block">
                  <p-multiSelect
                    [options]="forwarderOptions"
                    formControlName="forwarderCode"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    [filter]="true"
                  ></p-multiSelect>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "IntransitUpdate.Search.shipperCountry" | translate }}
                </div>
                <div class="block">
                  <p-dropdown
                    formControlName="shipperCountry"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    [(ngModel)]="searchParams.shipperCountry"
                    [options]="countryOptions"
                    [filter]="true"
                    filterBy="label"
                    (onChange)="getshipperCityOptions()"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "IntransitUpdate.Search.shipperCity" | translate }}
                </div>
                <div class="block">
                  <p-dropdown
                    formControlName="shipperCity"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    [(ngModel)]="searchParams.shipperCity"
                    [options]="shipperCityOptions"
                    [filter]="true"
                    filterBy="label"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "IntransitUpdate.Search.consigneeCountry" | translate }}
                </div>
                <div class="block">
                  <p-dropdown
                    formControlName="consigneeCountry"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    [(ngModel)]="searchParams.consigneeCountry"
                    [options]="countryOptions"
                    [filter]="true"
                    filterBy="label"
                    (onChange)="getconsigneeCityOptions()"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "IntransitUpdate.Search.consigneeCity" | translate }}
                </div>
                <div class="block">
                  <p-dropdown
                    formControlName="consigneeCity"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    [(ngModel)]="searchParams.consigneeCity"
                    [options]="consigneeCityOptions"
                    [filter]="true"
                    filterBy="label"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                <laas-calendar
                  [title]="'IntransitUpdate.Search.bookingDate'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event, 'bookingDate')"
                >
                </laas-calendar>
              </div>
              <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                <laas-calendar
                  [title]="'IntransitUpdate.Search.pickUpDate'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event, 'pickUpDate')"
                >
                </laas-calendar>
              </div>
              <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                <laas-calendar
                  [title]="'IntransitUpdate.Search.completeDeliveryTime'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event, 'completeDeliveryTime')"
                >
                </laas-calendar>
              </div>
              <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                <laas-calendar
                  [title]="'IntransitUpdate.Search.etd'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event, 'etd')"
                >
                </laas-calendar>
              </div>
              <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                <laas-calendar
                  [title]="'IntransitUpdate.Search.eta'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event, 'eta')"
                >
                </laas-calendar>
              </div>
              <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                <laas-calendar
                  [title]="'IntransitUpdate.Search.edc'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event, 'edc')"
                >
                </laas-calendar>
              </div>
              <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                <laas-calendar
                  [title]="'IntransitUpdate.Search.atd'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event, 'atd')"
                >
                </laas-calendar>
              </div>
              <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                <laas-calendar
                  [title]="'IntransitUpdate.Search.ata'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event, 'ata')"
                >
                </laas-calendar>
              </div>
              <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                <laas-calendar
                  [title]="'IntransitUpdate.Search.estimatedPortClearanceTime'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="
                    dateOnChange($event, 'estimatedPortClearanceTime')
                  "
                >
                </laas-calendar>
              </div>
              <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                <laas-calendar
                  [title]="'IntransitUpdate.Search.actualPortClearanceTime'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="
                    dateOnChange($event, 'actualPortClearanceTime')
                  "
                >
                </laas-calendar>
              </div>
            </div>

            <!---- 查詢表單功能Button --------------------------------------------------------------------------------------------------------->
            <div class="col-12">
              <div class="inline-block mb-1">
                <button
                  pButton
                  pRipple
                  label="{{ 'Common.Button.Search' | translate }}"
                  (click)="searchBtnClick()"
                ></button>
              </div>
              <div class="inline-block mb-1">
                <button
                  pButton
                  pRipple
                  label="{{ 'Common.Button.Reset' | translate }}"
                  class="p-button-secondary"
                  (click)="resetBtnClick()"
                ></button>
              </div>
              <div class="inline-block mb-1">
                <button
                  pButton
                  pRipple
                  label="{{ 'Common.Button.Import' | translate }}"
                  (click)="visibleChangeOfIntransitImport(true)"
                ></button>
              </div>
              <div class="inline-block mb-1">
                <button
                  pButton
                  pRipple
                  label="{{ 'Common.Button.Export' | translate }}"
                  (click)="downloadExcelBtn($event)"
                ></button>
              </div>
              <div class="inline-block mb-1">
                <button
                  pButton
                  pRipple
                  label="{{ 'IntransitImport.Button.Download' | translate }}"
                  (click)="templateDownloadBtn()"
                ></button>
              </div>
              <strong class="p-invalid">
                {{ "IntransitImport.Message.NotificationMsg" | translate }}
              </strong>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>

    <div class="mt-2">
      <laas-data-table
        [selectable]="false"
        [(selectedRows)]="selectedRows"
        [value]="rows"
        [loading]="isLoading"
        [defaultColumns]="intransitColumns"
      >
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'createDt'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date
                        : "yyyy-MM-dd HH:mm:ss"
                        : this.laasSetting.facilityTimeZone
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'updateDt'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date
                        : "yyyy-MM-dd HH:mm:ss"
                        : this.laasSetting.facilityTimeZone
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'bookingDate'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date
                        : "yyyy-MM-dd HH:mm:ss"
                        : this.laasSetting.facilityTimeZone
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'pickUpDate'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date
                        : "yyyy-MM-dd HH:mm:ss"
                        : this.laasSetting.facilityTimeZone
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'completeDeliveryTime'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date
                        : "yyyy-MM-dd HH:mm:ss"
                        : this.laasSetting.facilityTimeZone
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'etd'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date
                        : "yyyy-MM-dd HH:mm:ss"
                        : this.laasSetting.facilityTimeZone
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'eta'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date
                        : "yyyy-MM-dd HH:mm:ss"
                        : this.laasSetting.facilityTimeZone
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'edc'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date
                        : "yyyy-MM-dd HH:mm:ss"
                        : this.laasSetting.facilityTimeZone
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'ata'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date
                        : "yyyy-MM-dd HH:mm:ss"
                        : this.laasSetting.facilityTimeZone
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'atd'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date
                        : "yyyy-MM-dd HH:mm:ss"
                        : this.laasSetting.facilityTimeZone
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'estimatedPortClearanceTime'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date
                        : "yyyy-MM-dd HH:mm:ss"
                        : this.laasSetting.facilityTimeZone
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'actualPortClearanceTime'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date
                        : "yyyy-MM-dd HH:mm:ss"
                        : this.laasSetting.facilityTimeZone
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'deliveryWarehouse'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping : facilityOptions
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'forwarderName'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping : forwarderOptions
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'shipperCountry'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping : countryOptions
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'shipperCity'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping : allCityOptions
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'consigneeCountry'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping : countryOptions
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'consigneeCity'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping : allCityOptions
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <ng-container *ngSwitchDefault>
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith : "-" }}
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
  <ng-container *ngIf="isShowIntransitImport">
    <laas-intransit-import
      [(visible)]="isShowIntransitImport"
      (visibleChange)="visibleChangeOfIntransitImport($event)"
    ></laas-intransit-import>
  </ng-container>
</div>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
